import React from "react";
import { useTranslation } from "react-i18next";
import { Caption1, DisplayCurrency, InfoIcon, Tooltip } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { ROW_CLASSES_SHARED, ROW_CLASSES_TOTAL } from "./utils";

export const CostSummaryTotalRow = ({
  boldLabel,
  label,
  value,
  currencyCode,
  decimalSeparator,
  thousandSeparator,
  decimalSpaces,
  withoutInternalRate,
}) => {
  const { t } = useTranslation();

  return (
    <div className={classNames(ROW_CLASSES_TOTAL, ROW_CLASSES_SHARED)}>
      <Caption1
        weight={boldLabel ? "bold" : "regular"}
        color={boldLabel ? "secondary" : "tertiary"}
        align="right"
      >
        {label}
      </Caption1>
      <div className="tw-flex tw-gap-1.5 tw-text-right tw-items-center tw-justify-end">
        {withoutInternalRate ? (
          <Tooltip title={t("Internal rates missing")}>
            <InfoIcon
              fill="var(--red-alert)"
              className="tw-w-[18px] tw-h-[18px]"
            />
          </Tooltip>
        ) : null}
        <DisplayCurrency
          variant="Caption 1"
          weight="bold"
          align="right"
          color="secondary"
          currencyPosition="right"
          decimalSeparator={decimalSeparator}
          decimalSpaces={decimalSpaces}
          thousandSeparator={thousandSeparator}
          currencyCode={currencyCode}
          format="short"
          value={value}
          trimDecimals={false}
        />
      </div>
    </div>
  );
};

CostSummaryTotalRow.propTypes = {
  currencyCode: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  boldLabel: PropTypes.bool,
  value: PropTypes.number.isRequired,
  thousandSeparator: PropTypes.string,
  decimalSeparator: PropTypes.string,
  decimalSpaces: PropTypes.number,
  withoutInternalRate: PropTypes.bool,
};

CostSummaryTotalRow.defaultProps = {
  decimalSeparator: ".",
  thousandSeparator: ",",
  decimalSpaces: 2,
};
